import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Timer } from "lucide-react";
import { useApi, errMsg, ago, fmtDate, isStalled } from "@/lib/api";

export const RQPanel = () => {
  const api = useApi();
  const [d, setD] = useState(null);
  const load = useCallback(() => api("get", "/admin/rq").then(setD).catch(() => {}), [api]);
  useEffect(() => { load(); }, [load]);
  const stalled = isStalled(d?.last_job);
  const running = d?.last_job?.state === "generating" && !stalled;
  useEffect(() => { if (!running) return undefined; const t = setInterval(load, 5000); return () => clearInterval(t); }, [running, load]);
  if (!d) return null;

  const fetchNow = async () => {
    try { await api("post", "/admin/rq/fetch"); toast.success("Downloading new sectional files in the background"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const j = d.last_job;

  return (
    <section className="rounded-2xl bg-[#131C31] border border-white/5 p-5 space-y-3" data-testid="admin-rq-panel">
      <h2 className="font-display text-lg font-bold flex items-center gap-2"><Timer className="w-4 h-4 text-emerald-400" />QLD sectionals · Racing Queensland</h2>
      <p className="text-xs text-slate-500" data-testid="rq-status">
        {d.files} race days stored · {d.runs.toLocaleString()} horse runs{d.latest ? ` · latest ${d.latest.track} ${fmtDate(d.latest.date)}` : ""}
      </p>
      {j && (
        <p className="text-xs text-slate-400" data-testid="rq-job">
          {stalled ? <span className="text-rose-300">Stalled: no progress for over 15 minutes, so it probably stopped. Download again to continue.</span> : running ? `Downloading… ${j.done || 0}${j.total != null ? ` of ${j.total}` : ""} files` : j.state === "error" ? <span className="text-rose-300">{j.error}</span>
            : `Last download ${ago(j.finished_at)}: ${j.done || 0} new file(s)${j.errors ? `, ${j.errors} skipped` : ""}`}
        </p>
      )}
      <button data-testid="rq-fetch-button" onClick={fetchNow} disabled={running} className="px-4 py-1.5 rounded-full bg-emerald-600 hover:bg-emerald-500 text-xs font-semibold disabled:opacity-50">
        {running ? "Downloading…" : stalled ? "Run again" : "Download new files"}
      </button>
      <p className="text-[11px] text-slate-500">Free official files, fetched automatically Thursday and Sunday mornings. Used by the AI and shown to admins only, until Racing Queensland gives written consent for public use.</p>
    </section>
  );
};
